/* Local dependencies */
import { Warehouse } from '../../types';
import { GetWarehouseActionTypes, GetWarehouseError, GetWarehouseRequest, GetWarehouseSuccess } from './types';

export function getWarehouse(warehouseId: string): GetWarehouseRequest {
  return {
    type: GetWarehouseActionTypes.GET_WAREHOUSE,
    warehouseId,
  };
}

export function getWarehouseSuccess(warehouse: Warehouse): GetWarehouseSuccess {
  return {
    type: GetWarehouseActionTypes.GET_WAREHOUSE_SUCCESS,
    warehouse,
  };
}

export function getWarehouseError(error: Error): GetWarehouseError {
  return {
    type: GetWarehouseActionTypes.GET_WAREHOUSE_ERROR,
    error,
  };
}
